<div class="shadow" *ngIf="shadow"></div>
<span
  [ngClass]="{'product-detail-order-link': true, 'product-detail-order-link-active': active ? active : false}"
  [style.width]="widthPercentage? widthPercentage+'%':'50%'">
  <ng-content></ng-content>
</span>
